<template>
  <div
    :class="['filter-row px-0 pt-1 align-center', {'disabled' : disabled, 'is-not-use-mode': num == 0 || !withMode}]"
    :data-qa="'filter-row-' + num"
    @click.capture="validateRow">
    <v-select
      v-if="num != 0 && withMode"
      ref="select"
      v-model="contain_mode"
      class="filter-row__filters-mode h11-links my-0 py-0 mr-2 pr-2 select without-border input"
      color="var(--black-color)"
      data-qa="select-contain_mode-for-all"
      dense
      :disabled="num > 1"
      hide-details
      :items="necessarily_modes"
      :menu-props="menuProps"
      :readonly="disabled">
      <template #append>
        <sIcon
          class="my-auto"
          size="10"
          type="arrow"/>
      </template>
    </v-select>
    <slot
      :disabled="disabled"
      :item="item"
      name="type">
      <v-select
        v-model="item"
        class="filter-row__title h11-links my-0 mr-2 pr-2 select without-border input"
        :class="inline_input_style.class"
        color="var(--black-color)"
        data-qa="select-item"
        dense
        hide-details
        item-text="title"
        item-value="id"
        :items="items"
        :menu-props="menuProps"
        :readonly="disabled"
        return-object
        :style="inline_input_style.style"
        @change="ev => $emit('change-type', ev, elem)">
        <template #append>
          <sIcon
            class="my-auto"
            size="10"
            type="arrow"/>
        </template>
      </v-select>
    </slot>
    <slot
      :disabled="disabled"
      :item="item"
      name="contain">
      <v-select
        v-model="item.contain"
        class="filter-row__current-contain my-0 mr-2 select without-border input h11-links"
        color="var(--black-color)"
        data-qa="select-item-contain_mode"
        dense
        hide-details
        :items="contain_modes"
        :menu-props="menuProps"
        :readonly="disabled"
        @change="ev => $emit('change-contain-mode', ev, elem)">
        <template #append>
          <sIcon
            class="my-auto"
            size="10"
            type="arrow"/>
        </template>
      </v-select>
    </slot>
    <div class="filter-row__value">
      <slot
        :disabled="disabled"
        :item="item"
        name="activator"/>
    </div>
    <sButton
      data-qa="btn-delete-template"
      :disabled="disabled"
      icon="delete"
      small
      type="text"
      @click="$emit('cancel', elem)"/>
  </div>
</template>

<script>
export default {
  name: 'filterRow',
  data() {
    return {
      necessarily_modes: [
        {text: this.$t('Common.Also').toLocaleUpperCase(), value: true},
        {text: this.$t('Common.Or').toLocaleUpperCase(), value: false},
      ],
      contain_modes: [
        {text: this.$t('Common.Contains'), value: true},
        {text: this.$t('Common.NotContains'), value: false},
      ]
    }
  },
  props: {
    items: Array,
    elem: Object,
    num: Number,
    mode: Boolean,
    disabled: Boolean,
    withMode: {
      type: Boolean,
      default: true
    },
    'menu-props': {
      type: Object,
      default: () => {
        return {
          maxHeight: '50%'
        }
      }
    },
    maxWidth: {
      type: [Number, String]
    }
  },
  computed: {
    item: {
      get() {
        return this.elem
      },
      set(value) {
        this.$emit('update:elem', value)
      }
    },
    contain_mode: {
      get() {
        return this.mode
      },
      set(value) {
        this.$emit('update:mode', value)
      }
    },
    inline_input_style() {
      if (this.maxWidth) {
        return {
          style: {
            maxWidth: this.maxWidth + 'px',
          },
          class: 'filter-row-input-normal-space'
        }
      }
      return {}
    }
  },
  methods: {
    validateRow(event) {
      if ( this.disabled ) {
        event.stopPropagation()
      }
    }
  }
}
</script>

<style lang="scss">
.filter-row {
  display: grid;
  grid-template-columns: 65px auto 125px 200px 40px;
  &.is-not-use-mode {
    grid-template-columns: auto 125px 200px 40px;
  }
  &.disabled {
    * {
      cursor: default;
    }
  }
  .filter-row__title {
    flex-grow: 1;
  }
  .filter-row__filters-mode {
    flex-grow: 0;
    .s-input__inner {
      padding: 0;
    }
  }
  .input {
    &.filter-row__current-contain {
      .v-input__control {
        display: flex;
        align-items: flex-end;
      }
    }
    &, .v-input__slot , .v-select__slot {
      width: min-content;
    }
    .v-input__control {
      width: min-content;
      display: block;
    }
    .v-select__selection {
      max-width: unset;
    }
  }

  .v-select-list {
    z-index: 260;
  }
  .filter-row-input-normal-space .v-select__selection {
    white-space: normal;
  }
  &__value {
    width: 205px;
  }
}
</style>
